import * as React from "react";
import { FieldsContext } from "../FieldsContext";
import { FocusFormTab } from "./FocusFormTab";
import { buildFormComponent, setAll2Readonly } from "./utils";
export const FocusFormBuilder = ({ hasTab, schema, uiSchema, formData, readOnly, errors, onChange }) => {
    const buildForm = () => {
        const fields = React.useContext(FieldsContext);
        let formComponents = [];
        const order = uiSchema["ui:order"];
        for (let i = 0; i < order.length; i++) {
            const fieldName = order[i];
            formComponents.push(buildFormComponent(fieldName, fields, schema, uiSchema, formData, errors, handleChange));
        }
        return formComponents;
    };
    const handleChange = (fieldName) => (newData, change) => {
        let newFormData = Object.assign({}, formData);
        newFormData[fieldName] = newData;
        onChange(newFormData, change);
    };
    if (readOnly) {
        uiSchema = setAll2Readonly(uiSchema);
    }
    if (hasTab) {
        return (React.createElement(FocusFormTab, { schema: schema, uiSchema: uiSchema, formData: formData, errors: errors, onChange: onChange }));
    }
    else {
        const formComponents = buildForm();
        return React.createElement("div", { role: "subform" }, formComponents);
    }
};
//# sourceMappingURL=FocusFormBuilder.js.map